import { Lightbulb, Sparkles } from 'lucide-react'
import { useState } from 'react'
import { cn } from 'lib/utils'
import { useQueuedPromptStore } from '../../store/conversation-store'

/**
 * The judge's single highest-leverage fix + a one-tap button that queues it to the chat
 * (SideChat's queued-prompt effect sends it when idle → a real revise + live ladder). Shared
 * by the ScorePanel breakdown and the blocked-post chat opener so the fix CTA — wording,
 * queued-prompt prefix, disabled state — stays identical in both places.
 */
export function FixWithTakaCard({
  creativeId,
  singleFix,
  className,
}: {
  creativeId: string
  singleFix: string
  className?: string
}) {
  const setQueuedPrompt = useQueuedPromptStore(s => s.setPrompt)
  const [fixSent, setFixSent] = useState(false)

  return (
    <div className={cn('flex flex-col gap-2 rounded-md bg-bg-3 p-2', className)}>
      <div className="flex items-start gap-2">
        <Lightbulb size={14} className="mt-0.5 flex-shrink-0 text-acid" />
        <p className="text-xs leading-snug text-paper-dim">{singleFix}</p>
      </div>
      <button
        type="button"
        disabled={fixSent}
        onClick={() => {
          setQueuedPrompt(creativeId, `Fix this: ${singleFix}`)
          setFixSent(true)
        }}
        className="text-ink-on-acid ml-[22px] inline-flex w-fit items-center gap-1.5 rounded-[6px] bg-acid px-2.5 py-1 text-[12px] font-medium transition-colors hover:bg-acid/90 disabled:opacity-60"
      >
        <Sparkles size={12} />
        {fixSent ? 'Sent to Taka…' : 'Fix this with Taka'}
      </button>
    </div>
  )
}
